/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Proceed_To_PaymentInputs */

const en_common_proceed_to_payment = /** @type {(inputs: Common_Proceed_To_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceed to Payment`)
};

const es_common_proceed_to_payment = /** @type {(inputs: Common_Proceed_To_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al pago`)
};

/**
* | output |
* | --- |
* | "Proceed to Payment" |
*
* @param {Common_Proceed_To_PaymentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_proceed_to_payment = /** @type {((inputs?: Common_Proceed_To_PaymentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Proceed_To_PaymentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_proceed_to_payment(inputs)
	return en_common_proceed_to_payment(inputs)
});